document.addEventListener("DOMContentLoaded", () => {

  document.querySelectorAll("[data-author-initials]").forEach((el) => {
    const name = el.textContent.trim();

    if (!name) return;

    const initials = name
      .split(/\s+/)
      .filter(Boolean)
      .map((part) => part[0])
      .join("")
      .slice(0, 2)
      .toUpperCase();

    el.textContent = initials;
  });

});
